export default __webpack_public_path__ + "media/images/shde-right-7898d672de47ce038b3262f566f818f0.png";